<template>
  <div class="list page-container">
    <div class="page-title">
      {{ $t('menu.merchant_list') }}
    </div>

    <div class="filter-right-container">
      <div class="filter-container-tag">
        {{ $t('components.activity') }}
      </div>
      <el-popover
        placement="bottom"
        trigger="click"
      >
        <div class="filter-section-container">
          <div id="filter-content" class="filter-content">

            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchant.merchant_no') + '/' + $t('merchant.merchant_name') }}
              </div>
              <SearchAgentSelect v-model="search.merchant_name_no" size="medium" style="width: 100%" />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('components.status') }}</div>
              <el-select v-model="search.status" class="filter-item-value" clearable>
                <el-option
                  v-for="(item,index) in auditStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filter-item" />

          </div>
          <div class="filter-operate">
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>
        <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
      </el-popover>
    </div>

    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('merchant.merchant_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.merchant_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_name }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('components.status')" min-width="170" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" style="min-width: 120px" :type="getStatus(scope.row).type">{{ getStatus(scope.row).label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('components.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('merchantAccount.update_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.update_time }}</span>
          </template>
        </el-table-column> -->

      </el-table>

      <!-- <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div> -->
    </div>
  </div>
</template>

<script>

import { fetchMchListByAgent } from '@/api/agent-merchant/agent-merchant'
import { auditStatusMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
import SearchAgentSelect from '@/components/SearchAgentSelect'
export default {
  name: 'List',
  components: {
    Paginator: () => import('@/views/components/Paginator.vue'),
    SearchAgentSelect
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        status: null,
        merchant_name_no: null
      },
      merchantList: [],
      loading: false,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },

  computed: {
    auditStatusMap() {
      return auditStatusMap()
    },
    getStatus() {
      return function(row) {
        let value = row.final_audit_status
        if (row.audit_status === 1 || (row.audit_status === 4 && row.final_audit_status === 1) || (row.audit_status === 3 && row.final_audit_status === 1)) {
          value = 1
        }

        if (row.audit_status === 2 || row.final_audit_status === 2) {
          value = 2
        }

        if (row.final_audit_status === 3) {
          value = 3
        }

        if (row.final_audit_status === 4) {
          value = 4
        }

        return auditStatusMap(value)
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchMchListByAgent(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data || []
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 列表请求参数
    getParams(otherParams = {}) {
      const { ...otherSearchParams } = this.search
      let params = { ...otherSearchParams, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },
    onClickSearchBtn() {
      this.getList()
    },
    onClickPaginator() {
      this.getList(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.list{
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .btn {
    margin: 0;
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .order-number{
    width: 250px;
  }
  .transTime{
    display: inline-block;
    padding-right: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    font-family: 'Poppins-Medium';
  }
  .dateRange{
    margin-right: 20px;
  }
  .mb10{
    margin-bottom: 10px;
  }
}

</style>
